import { Injectable } from '@angular/core';
import { CmsComponentConfig, Member, Team } from '@interfaces/config';

import { CmsComponentNodeData } from '@interfaces/cms-component-node-data';
import { ParagraphMemberData, ParagraphTeamData } from '@generated/content';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { MemberComponentResolver } from '@services/resolvers/component-resolvers/member-component/member-component-resolver';

@Injectable({ providedIn: 'root' })
export class TeamComponentResolver extends BaseComponentResolver {
  static override instance: TeamComponentResolver;
  private readonly componentType = Team.TypeEnum;

  static getInstance(): TeamComponentResolver {
    return (TeamComponentResolver.instance ||= new TeamComponentResolver());
  }

  public resolveComponentConfig(
    node: ParagraphTeamData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<Team.ComponentConfig> {
    if (!node) {
      return null;
    }

    this.nodePageData = nodePageData;

    const memberNodeIds = node.relationships.field_members.data.map(d => d.id);
    const memberNodes = nodePageData
      .filter(node => node.type === ParagraphMemberData.TypeEnum.ParagraphMember)
      .filter(node => memberNodeIds.includes(node.id));

    const memberResolver = MemberComponentResolver.getInstance();

    const members: Member.ComponentConfig[] = memberNodes.map(
      (node: ParagraphMemberData) => memberResolver.resolveComponentConfig(node, nodePageData)?.config
    );

    return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        headline: this.hyphenate(node.attributes.field_headline_team),
        members,
      },
    };
  }
}
